export default __webpack_public_path__ + "static/media/p4-homepage.9b11d990.png";